module.exports = __webpack_public_path__ + "static/media/icon-juridico.a0d00c03.svg";